<template>
  <!-- https://stackoverflow.com/questions/61444870/maximum-call-stack-size-exceeded-vuetify -->
  <v-dialog
    v-model="dialog"
    max-width="600"
    :retain-focus="false"
    persistent
    hide-overlay
  >
    <v-card class="primary pa-4">
      <div
        class="primary navy--text text--darken-1 pt-2 px-2 d-flex align-center font-hemi-head"
      >
        <v-icon class="white--text" left>design_services</v-icon>
        <span class="white--text" style="font-size: 18px"
          >PIANIFICAZIONE CREDITI <br />(Ex Asta-Manager)</span
        >
        <v-spacer></v-spacer>
        <v-btn depressed icon @click="dismiss()">
          <v-icon>close</v-icon>
        </v-btn>
      </div>
      <div class="pa-4 white--text">
        <!-- accordion -->
        <v-expansion-panels flat tile :value="[1]">
          <v-expansion-panel>
            <v-expansion-panel-header class="font-hemi-head">
              COME FUNZIONA
              <template v-slot:actions>
                <v-icon class="text--white">fa-caret-down </v-icon>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div>
                <div class="pt-2 navy--text text--darken-2">
                  <b>A cosa serve?</b>
                </div>
                <div>
                  La pianificazione dei crediti prima dell'asta e il fatto che
                  Asta Live ti aiuta a aggiornarla in tempo reale è uno
                  strumento di grandissimo aiuto per non cadere nel tipico
                  errore di spendere troppo per qualche calciatore durante le
                  concitate fasi d'asta e rimanere quindi poi con pochi crediti
                  per completare la rosa. Col risultato finale di avere una
                  squadra non equilibrata.
                </div>
                <div class="pt-2 navy--text text--darken-2">
                  <b>Cosa devi fare?</b>
                </div>
                <ul>
                  <li>
                    Pianifica quanti crediti vorresti spendere per ciascuno
                    slot.
                  </li>
                  <li>
                    (Opzionale) Pianifica lista obiettivi (nomi calciatori) per
                    ciascuno slot.
                  </li>
                </ul>
                <div class="pt-2 navy--text text--darken-2"><b>E poi?</b></div>
                Durante l'asta man mano che acquisti calciatori:
                <ul>
                  <li>
                    Asta Live "inserisce" in automatico il calciatore comprato
                    nello slot adeguato (sostituendo i crediti pianificati con
                    quelli effettivamente spesi)
                  </li>
                  <li>
                    Se hai speso di più o di meno di quanto pianificato per
                    quello slot, Asta Live ti avvisa quanti crediti devi
                    ridistribuire tra gli slot liberi rimanenti
                  </li>
                  <li>
                    Rimuove automaticamente dalla tua lista gli obiettivi non
                    più disponibili
                  </li>
                </ul>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <!-- numero calciatori -->
        <div
          v-if="asta_info.lega.nRuoli.op == 'illimitati'"
          class="d-flex flex-column pt-4"
        >
          <div>
            <div class="navy--text text--darken-2">
              <b>Numero calciatori</b>
            </div>
            In questa lega ci sono acquisti "illimitati / a piacere". Per poter
            procedere a una pianificazione devi innanzitutto impostare quanti
            calciatori intendi acquistare per ciascun ruolo
          </div>
          <div class="d-flex align-center">
            <v-select
              class="ma-1"
              :class="{ invalido: !nP_items.includes(nP) }"
              v-model="nP"
              :items="nP_items"
              label="P"
              required
              solo
              flat
              dense
              hide-details
            ></v-select>
            <v-select
              class="ma-1"
              :class="{ invalido: !nD_items.includes(nD) }"
              v-model="nD"
              :items="nD_items"
              label="D"
              required
              solo
              flat
              dense
              hide-details
            ></v-select>
            <v-select
              class="ma-1"
              :class="{ invalido: !nC_items.includes(nC) }"
              v-model="nC"
              :items="nC_items"
              label="C"
              required
              solo
              flat
              dense
              hide-details
            ></v-select>
            <v-select
              class="ma-1"
              v-model="nA"
              :class="{ invalido: !nA_items.includes(nA) }"
              :items="nA_items"
              label="A"
              required
              solo
              flat
              dense
              hide-details
            ></v-select>
          </div>
          <div v-if="mantra">
            <v-icon left>warning</v-icon> Sebbene sia una lega a Mantra, per la
            pianificazione dei ruoli da acquistare si fa riferimento ai ruoli
            <b>classici</b> (identificabili dal bordo sinistro del rettangolo
            intorno al calciatore)
          </div>
        </div>
        <!-- strategia -->
        <div class="d-flex flex-column pt-4">
          <div class="">
            <div class="navy--text text--darken-2">
              <b>Inizializza distribuzione crediti</b>
            </div>
            Per velocizzare la pianificazione iniziale dei crediti, scegli lo
            schema che vorresti utilizzare e Asta Live distribuirà i crediti tra
            i vari slot adeguatamente. Ovviamente potrai sempre modificare la
            distribuzione anche manualmente.
          </div>
          <div class="py-4">
            <!-- <v-btn disabled class="white" depressed @click="promptStrategia"> Scegli Strategia </v-btn> -->
            <!-- v-model="strategia" -->
            <v-select
              class=""
              v-model="strategiaModel"
              :items="strategieOptions"
              label="Scegli schema"
              solo
              flat
              hide-details
              @change="strategiaChanged"
            ></v-select>
          </div>
        </div>
        <!-- Criterio slot -->
        <div class="pt-4">
          <div class="navy--text text--darken-2">
            <b>Criterio scelta slot</b>
          </div>

          - Quando acquisti un calciatore presente nella "Lista Obiettivi", Asta
          Live lo inserisce automaticamente nel relativo slot.<br />
          - Quando invece acquisti un calciatore che non hai messo nella "Lista
          Obiettivi", in quale slot deve inserirlo Asta Live?
          <v-select
            class="py-4"
            v-model="associazioneMethod"
            :items="getAssociazioneMethodSelectOptions()"
            solo
            flat
          ></v-select>
        </div>

        <!-- accordion -->
        <v-expansion-panels flat tile>
          <v-expansion-panel>
            <v-expansion-panel-header class="font-hemi-head">
              FAQ / Domande frequenti
              <template v-slot:actions>
                <v-icon class="text--white">fa-caret-down </v-icon>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div>
                <div class="pt-2 navy--text text--darken-2">
                  <b
                    >Perchè sono scomparsi dei calciatori dalla mia lista
                    obiettivi?</b
                  >
                </div>
                <div>
                  Perchè non sono più disponibili tra gli svincolati: o sono
                  stati acquistati (da qualcun altro o da te), o sono stati
                  scartati, o non giocano più nel campionato
                </div>
                <div class="pt-2 navy--text text--darken-2">
                  <b
                    >Con che logica Asta Live sceglie in quale slot inserire il
                    calciatore appena acquistato?</b
                  >
                </div>
                <div>
                  Asta Live inizialmente cerca il primo slot libero in cui
                  eventualmente quel calciatore compare come obiettivo. Se non
                  lo trova o lo mette nel primo slot disponibile o chiede a te
                  con un popup non appena acquistato (dipende dalla tua scelta
                  nell'opzione "Criterio scelta slot")
                </div>
                <div class="pt-2 navy--text text--darken-2">
                  <b
                    >Asta Live mi ha inserito un calciatore acquistato in un
                    certo slot ma io vorrei inserirlo in un altro</b
                  >
                </div>
                <div>
                  Non c'è problema. Puoi toglierlo dallo slot (premendo sulla X
                  accanto al nome) e inserirlo in un altro slot (premendo sul
                  numero dello slot stesso)
                </div>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import Constants from "../../js/constants";
import mixins from "../../js/mixins";
import toast from "../../js/toast";
import Vuex from "vuex";
import db from "../../js/db";

export default {
  name: "dialog-plan-settings",
  mixins: [mixins, toast],
  components: {},
  mounted() {
    console.log("--> DialogPlanSettings mounted.");
    db.on("DialogPlanSettings", this.show);
  },
  destroyed() {
    console.log("<-- DialogPlanSettings destroyed.");
    db.off("DialogPlanSettings", this.show);
  },
  data() {
    return {
      dialog: false,
      strategiaModel: null,
      strategieOptions: [
        { value: "442", text: "Schema 442" },
        { value: "343", text: "Schema 343" },
        { value: "352", text: "Schema 352" },
        { value: "433", text: "Schema 433" },
      ],
      strategie: {
        442: {
          P: [6.1, 0.7, 0.4],
          D: [6.4, 5.3, 3.5, 2.5, 1.7, 1.2, 0.7, 0.4],
          C: [10.0, 7.1, 4.4, 3.1, 2.3, 1.5, 1.1, 0.5],
          A: [21.3, 12.0, 4.3, 2.0, 1.2, 0.4],
        },
        343: {
          P: [2.0, 0.7, 0.4],
          D: [3.2, 2.4, 2.0, 1.6, 1.1, 0.7, 0.7, 0.4],
          C: [7.9, 5.2, 3.5, 2.9, 1.7, 1.3, 0.5, 0.4],
          A: [30.7, 17.3, 8.4, 2.8, 1.6, 0.7],
        },
        352: {
          P: [2.7, 0.8, 0.4],
          D: [3.5, 2.7, 2.3, 1.9, 1.3, 0.8, 0.5, 0.4],
          C: [14.4, 10.0, 6.4, 5.7, 3.5, 1.3, 0.5, 0.5],
          A: [19.1, 13.7, 4.7, 1.7, 0.8, 0.4],
        },
        433: {
          P: [9.1, 0.5, 0.4],
          D: [9.6, 7.7, 5.6, 3.9, 2.0, 1.2, 0.8, 0.4],
          C: [7.6, 4.7, 3.5, 2.1, 1.1, 0.8, 0.4, 0.4],
          A: [19.1, 10.0, 5.7, 2.0, 1.1, 0.4],
        },
      },
    };
  },
  props: {
    // planDefault: {
    //   type: Object,
    //   required: true,
    // },
  },
  methods: {
    dismiss() {
      this.dialog = false;
    },
    show() {
      this.dialog = true;
      this.strategiaModel = null;
    },
    strategiaChanged(newStrategia) {
      Swal.fire({
        title: "Confermi?",
        html: "Se avevi già pianificato i crediti, verranno sovrascritti",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si",
        cancelButtonText: "Annulla",
      }).then((result) => {
        if (result.isConfirmed == true) {
          const strategia = this.strategie[newStrategia];
          let tot = 0;
          let output = {};
          const creditiLega = this.asta_info.lega.crediti;
          // per ciascun ruolo
          Object.entries(this.planDefault).forEach(
            ([ruolo_abc, slots], index) => {
              // inizializza output
              output[ruolo_abc] = [];
              // reverse perchè devo partire dagli scarsi
              // do "1" se sono + di 8
              // lo salto se sono meno di 8...
              // ... tanto l'ultimo (il + forte) lo calcolo come delta
              const budgetRuolo = parseInt(
                (creditiLega * _.sum(strategia[ruolo_abc])) / 100
              );
              const countSlots = _.size(slots);

              const reversedKeys = Object.keys(slots).reverse();
              let budgetRuoloConsumed = 0;
              let budgetSlot = 0;
              reversedKeys.forEach((slot, index) => {
                const originalIndex = countSlots - index - 1;
                // inizializza output
                output[ruolo_abc][slot] = {};
                if (index === countSlots - 1) {
                  // l'ultimo lo calcolo come delta per essere sicuro si spendere tutto il budget
                  budgetSlot = parseInt(budgetRuolo - budgetRuoloConsumed);
                } else {
                  const perc = strategia[ruolo_abc][originalIndex];
                  budgetSlot = parseInt((creditiLega * perc) / 100) || 1;
                  budgetRuoloConsumed = budgetRuoloConsumed + budgetSlot;
                }
                output[ruolo_abc][slot]["crediti"] = budgetSlot;
                tot = tot + budgetSlot;
              });
            }
          );

          // se ci fossero delle differenze mettile tutte sul primo attaccante
          output.A._1.crediti = output.A._1.crediti + (creditiLega - tot);

          db.updatePlan(output)
            .then(() => {
              this.successToast("Complimenti!", "Crediti distribuiti");
            })
            .catch(() => {
              this.errorToast("Errore", "Operazione non riuscita");
            });
        }
      });
    },
  },
  computed: {
    nP_items() {
      const ruolo_id = 1;
      const squadra_id = this.my_squadra.id;
      const min = this.acquistiPerRuolo(ruolo_id, squadra_id) || 1;
      return _.range(min, 25); // per avere 24
    },
    nD_items() {
      const ruolo_id = 2;
      const squadra_id = this.my_squadra.id;
      const min = this.acquistiPerRuolo(ruolo_id, squadra_id) || 1;
      return _.range(min, 25); // per avere 24
    },
    nC_items() {
      const ruolo_id = 3;
      const squadra_id = this.my_squadra.id;
      const min = this.acquistiPerRuolo(ruolo_id, squadra_id) || 1;
      return _.range(min, 25); // per avere 24
    },
    nA_items() {
      const ruolo_id = 4;
      const squadra_id = this.my_squadra.id;
      const min = this.acquistiPerRuolo(ruolo_id, squadra_id) || 1;
      return _.range(min, 25); // per avere 24
    },
    associazioneMethod: {
      get() {
        return this.my_squadra.settings.plan.associazione;
      },
      set(value) {
        db.setSettingsPlanAssociazione(value);
      },
    },
    nP: {
      get() {
        return this.my_squadra.settings.plan.nRuoli.nP;
      },
      set(value) {
        db.setSettingsPlanNRuoli("nP", value);
      },
    },
    nD: {
      get() {
        return this.my_squadra.settings.plan.nRuoli.nD;
      },
      set(value) {
        db.setSettingsPlanNRuoli("nD", value);
      },
    },
    nC: {
      get() {
        return this.my_squadra.settings.plan.nRuoli.nC;
      },
      set(value) {
        db.setSettingsPlanNRuoli("nC", value);
      },
    },
    nA: {
      get() {
        return this.my_squadra.settings.plan.nRuoli.nA;
      },
      set(value) {
        db.setSettingsPlanNRuoli("nA", value);
      },
    },
    ...Vuex.mapGetters(["planDefault"]),
  },
};
</script>
<style lang="scss" scoped>
.v-expansion-panel-header {
  background: var(--v-primary-darken1);
  color: white;
}

.invalido {
  box-shadow: 0 0 0px 2px var(--v-error-base);
}
</style>
